/* Consistent, accessible upload actions for explicitly native product forms. */
(function (global, document) {
  'use strict';
  if (global.FSNativeUploadControls) return;

  const FORM_SELECTOR = 'form[data-fs-native-mode="native"]';
  const PROPERTY_UPLOAD = /^properties\[UPLOAD IMAGE\(S\)(?:_[^\]]+)?\]$/i;
  const DECORATED = 'data-fs-native-upload-enhanced';
  const ACTION_TEXT = 'Upload Photo(s)';
  let fallbackId = 0;
  let started = false;

  function nextId() {
    let id;
    do {
      fallbackId += 1;
      id = `fs-native-upload-${fallbackId}`;
    } while (document.getElementById(id));
    return id;
  }

  function fileInputs(form) {
    return [...form.querySelectorAll('input[type="file"]')].filter(input => {
      if (input.disabled || input.matches('[data-fs-bulk-file-slot],[data-fs-bulk-tee-file-slot],.fs-bulk__replace-picker,.fs-bulk-tee__replace-picker')) return false;
      return PROPERTY_UPLOAD.test(input.name || '') || input.matches('[data-fs-bulk-file-picker],[data-fs-bulk-tee-file]');
    });
  }

  function uploadHeading(input) {
    const fieldset = input.closest('fieldset');
    const legend = fieldset?.querySelector(':scope > legend');
    if (legend && /upload\s+image\s*\(s\)/i.test(legend.textContent || '')) {
      legend.classList.add('fs-native-upload-visually-hidden');
      legend.dataset.fsNativeUploadHeading = '';
    }
  }

  function associatedLabels(input) {
    return [...(input.labels || [])].filter(label => !label.classList.contains('fs-native-upload-control'));
  }

  function genericSlotLabel(label) {
    return /^(?:photo|image)\s+\d+(?:\s*\(optional\))?$/i.test(label.textContent.trim());
  }

  function genericUploadLabel(label) {
    return /^upload\s+image\s*\(s\)\s*\*?$/i.test(label.textContent.trim());
  }

  function setAccessibleName(input, labels) {
    const existing = input.getAttribute('aria-label');
    if (existing) {
      if (/^(?:photo|image)\s+\d+(?:\s*\(optional\))?$/i.test(existing.trim())) input.setAttribute('aria-label', ACTION_TEXT);
      return;
    }
    const meaningful = labels.filter(label => !genericSlotLabel(label) && !genericUploadLabel(label)).map(label => label.textContent.trim()).filter(Boolean);
    input.setAttribute('aria-label', meaningful.length ? `${ACTION_TEXT} — ${meaningful.join(', ')}` : ACTION_TEXT);
  }

  function icon() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.innerHTML = '<path d="M12 16V4m0 0L7 9m5-5 5 5M5 14v5h14v-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>';
    return svg;
  }

  function enhance(input) {
    if (input.hasAttribute(DECORATED)) return;
    const labels = associatedLabels(input);
    uploadHeading(input);
    labels.filter(label => genericSlotLabel(label) || genericUploadLabel(label)).forEach(label => label.classList.add('fs-native-upload-visually-hidden'));
    setAccessibleName(input, labels);

    if (!input.id) input.id = nextId();
    const shell = document.createElement('span');
    shell.className = 'fs-native-upload-shell';
    shell.dataset.fsNativeUploadShell = '';
    const action = document.createElement('label');
    action.className = 'fs-native-upload-control';
    action.htmlFor = input.id;
    action.append(icon());
    const text = document.createElement('span');
    text.className = 'fs-native-upload-control__text';
    text.textContent = ACTION_TEXT;
    action.append(text);

    // Keep the original input node and every upload property intact. Wrapping
    // only the visible picker gives CSS a safe overlay surface without a proxy.
    input.parentNode.insertBefore(shell, input);
    shell.append(action, input);
    input.classList.add('fs-native-upload-input');
    input.setAttribute(DECORATED, 'true');
  }

  function enhanceForm(form) {
    if (!(form instanceof global.HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;
    fileInputs(form).forEach(enhance);
  }

  function scan(node) {
    if (!(node instanceof global.Element) && node !== document) return;
    if (node instanceof global.Element && node.matches(FORM_SELECTOR)) enhanceForm(node);
    node.querySelectorAll?.(FORM_SELECTOR).forEach(enhanceForm);
    const form = node instanceof global.Element ? node.closest(FORM_SELECTOR) : null;
    if (form) enhanceForm(form);
  }

  function start() {
    if (started) return;
    started = true;
    scan(document);
    const observer = new global.MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) scan(node);
      }
    });
    observer.observe(document.documentElement, {childList:true,subtree:true});
  }

  global.FSNativeUploadControls = Object.freeze({start});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})(window, document);
